import { fetchPosService } from "../fetchPosService";
import type {
  CartAddItemsMutation,
  CartAddItemsMutationVariables,
  PosCartAddItemsInput,
} from "../generates";
import { CartAddItemsDocument } from "../types";

export type AddCartItemProps = {
  input: PosCartAddItemsInput;
  storeCode?: string;
};

export const addCartItem = async ({
  input,
  storeCode,
}: AddCartItemProps): Promise<CartAddItemsMutation> => {
  return fetchPosService<CartAddItemsMutation, CartAddItemsMutationVariables>({
    query: CartAddItemsDocument,
    variables: {
      input,
    },
    store: storeCode,
  });
};
